"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Footer = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var react_intl_1 = require("react-intl");
var material_1 = require("@mui/material");
var App_1 = require("../../../components/App");
var consts_1 = require("../../consts");
var styles = __importStar(require("./Footer.module.css"));
var Footer = function (_a) {
    var _b = _a.marginType, marginType = _b === void 0 ? 'default' : _b;
    var intl = (0, react_intl_1.useIntl)();
    var widgetSettings = (0, react_1.useContext)(App_1.WidgetContext).widgetSettings;
    var margin = {
        default: '16px auto',
        chat: '20px auto 6px',
        knowledgeBase: '0 auto 16px',
    };
    var link = (widgetSettings === null || widgetSettings === void 0 ? void 0 : widgetSettings.application) === 'Happydesk' ? 'https://happydesk.ru' : 'https://pulsedesk.com';
    var utm = '?utm_source=webwidget';
    var linkColor = (widgetSettings === null || widgetSettings === void 0 ? void 0 : widgetSettings.backgroundColor) || consts_1.DEFAULT_BACKGROUND_COLOR;
    var linkText = (widgetSettings === null || widgetSettings === void 0 ? void 0 : widgetSettings.application) === 'Happydesk' ? 'Happydesk' : 'Pulsedesk';
    return ((0, jsx_runtime_1.jsx)("div", __assign({ className: styles.footer, style: { margin: margin[marginType] } }, { children: (0, jsx_runtime_1.jsxs)("span", { children: [intl.formatMessage({ id: 'footer' }), (0, jsx_runtime_1.jsx)(material_1.Link, __assign({ href: link + utm, style: { color: linkColor }, underline: 'none', target: '_blank' }, { children: linkText }))] }) })));
};
exports.Footer = Footer;
